export default class PfFile {
  constructor ({ _id, s3Key, fileName, mimeType, size, width, height, is360, created, modified, uploaderUserId, projectId, references, resolutions, isClipboardFile, imgSrc, fileLastModifiedAt, exifDateTimeOriginal } = { }) {
    if (!_id) {
      throw new Error('_id in PfFile must be defined')
    }

    this._id = _id
    this.s3Key = s3Key
    this.fileName = fileName
    this.mimeType = mimeType
    this.size = size
    this.width = width
    this.height = height
    this.is360 = is360
    this.created = created
    this.modified = modified
    this.exifDateTimeOriginal = exifDateTimeOriginal
    this.fileLastModifiedAt = fileLastModifiedAt
    this.uploaderUserId = uploaderUserId
    this.projectId = projectId
    this.references = references
    this.resolutions = resolutions
    this.isClipboardFile = isClipboardFile

    this.imgSrc = imgSrc // Only used in WEB
  }
}
